import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { ChiamaAPI, Bottone, Trad, Paginatore, BaseComponent, Tipo, CampoData } from '../components/';
import $ from 'jquery';
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';

interface IEstrattoContoListaState {
    Caricamento: boolean;
    Aggiornare: number;
    Dati?: Dati.CRisAPIPagineEstrattoConto;
    ParamAPIPagine: Dati.CParamAPIPagine;
    ParametriUtente: Dati.TListaParametri; //Salvati qui e trasferiti in Parametri quando l'utente clicca "Cerca"
    Parametri: Dati.TListaParametri;
}

export class EstrattoContoLista extends BaseComponent<Glob.IRouteGlobaleProps, IEstrattoContoListaState> {

    private ParametriFissi: Dati.TListaParametri = {};

    public constructor(props: any) {
        super(props);
        const Param: Dati.CParamAPIPagine = new Dati.CParamAPIPagine();
        Param.Sessione = Glob.GetSessione().Sessione;
        Param.Numero = 10;
        Param.Pagina = 1;
        this.state = { Aggiornare: 1, Caricamento: true, ParamAPIPagine: Param, Dati: undefined, Parametri: this.ParametriFissi, ParametriUtente: {} };
        this.OnInvio = this.OnInvio.bind(this);
        this.OnRis = this.OnRis.bind(this);
        this.OnErroreEstrattoConto = this.OnErroreEstrattoConto.bind(this);
        this.OnCambioPagina = this.OnCambioPagina.bind(this);
        //Con il bind si pu� scrivere: onChange={this.OnChange}
        //altrimenti va utilizzata la sintassi: onChange={(e) => this.OnChange(e)}
        this.OnChange = this.OnChange.bind(this);
    }

    Tabella: any = null;
    TabellaOrdinamento: [number, string] = [1, 'asc'];
    TabellaAggiorna = 0;

    private AttivaTabella() {
        if (this.TabellaAggiorna != this.state.Aggiornare) {
            this.TabellaAggiorna = this.state.Aggiornare;
            if (this.state.Dati != undefined) {
                const T = $(this.refs.tabella);

                this.Tabella = T.DataTable({
                    responsive: true,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: true,
                    destroy: true,
                    order: this.TabellaOrdinamento,
                    columnDefs: [
                        {
                            targets: [6], orderable: false
                        }
                    ]
                });

                T.one('order.dt', (e: any, settings: any) => {
                    const TO: any = this.Tabella.order();
                    if (TO != undefined && TO[0] != undefined) {
                        this.TabellaOrdinamento[1] = TO[0][1];
                        this.TabellaOrdinamento[0] = TO[0][0];
                        switch (this.TabellaOrdinamento[0]) {
                            case 0:
                                this.OnOrdinamento("ID_EstrattoConto", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 1:
                                this.OnOrdinamento("AnagDa", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 2:
                                this.OnOrdinamento("AnagA", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 3:
                                this.OnOrdinamento("DataDa", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 4:
                                this.OnOrdinamento("DataA", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                        }
                    }
                });
            }
        }
    }
    public componentDidMount() {
        this.AttivaTabella();
    }

    public componentDidUpdate() {
        this.AttivaTabella();
    }

    private OnInvio(sender: ChiamaAPI) {
        return this.UnisciListaParametri(this.state.Parametri, this.ParametriFissi);
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIPagineEstrattoConto, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.TabellaAggiorna = 0;
            if (this.Tabella != null) {
                this.Tabella.destroy();
            }
            this.setState({ Dati: dati, Caricamento: false }, () => this.AttivaTabella());
        }
        if (dati.Errore) {
            return false;
        }
        if (dati.Dati.length == 0) {
            return <tbody><tr>
                <td colSpan={8} className="TextLeft alert-warning">
                    <div className="kt-alert__icon">
                        <i className="fa fa-exclamation-triangle"> </i>
                        <span>{Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}</span>
                    </div>
                </td>
            </tr></tbody>;
        }
        else {
            return <tbody>
                {dati.Dati.map(dato =>
                    <tr key={dato.ID_EstrattoConto}>
                        <td className="TextCenter">
                            <a href="#" className="arrow" onClick={(e) => { e.preventDefault(); this.props.history.push("/EstrattoConto/" + dato.ID_EstrattoConto) }}>
                                {dato.ID_EstrattoConto}
                            </a>
                        </td>
                        <td className="TextLeft">{dato.AnagDa}</td>
                        <td className="TextLeft">{dato.AnagA}</td>
                        <td className="TextCenter">{Glob.DataValoreTrad(dato.DataDa)}</td>
                        <td className="TextCenter">{Glob.DataValoreTrad(dato.DataA)}</td>
                        <td className="TextRight">{Trad.TradParam("{1-I}", [dato.Totale])}</td>
                        <td className="TextCenter">{Trad.Trad(this.state.Dati?.Tipi["EstrattoContoStato"][dato.ID_TipoEstrattoContoStato].Valore ?? "")}</td>
                        <td className="TextCenter">
                            <a href="#" className="btn btn-brand kt-btn kt-btn--icon btn-sm btn--icon-only" onClick={(e) => { e.preventDefault(); this.props.history.push("/EstrattoConto/" + dato.ID_EstrattoConto) }}>
                                <i className="la la-edit"></i>
                            </a>
                        </td>
                    </tr>
                )}
            </tbody>;
        }
    }

    private OnErroreEstrattoConto(sender: ChiamaAPI, errore: Error) {
        this.setState({ Caricamento: false });
        return <tbody><tr><td colSpan={8}>{Trad.Trad("ListaErrore")}</td></tr></tbody>;
    }

    private OnCambioPagina(sender: Paginatore, pagina: number) {
        this.state.ParamAPIPagine.Pagina = pagina;
        this.setState({ ParamAPIPagine: this.state.ParamAPIPagine, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    private OnOrdinamento(Campo: string, Verso: string) {
        this.state.Parametri["OrdinaCampo"] = Campo;
        this.state.Parametri["OrdinaVerso"] = Verso;
        this.setState({ Parametri: this.state.Parametri, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    public render() {
        if (!this.ControlloAutorizzazione("EstrattoContoController")) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }
        const Scrittura = (Glob.AzioneAbilitata("EstrattoContoController", Glob.Scrittura));

        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-handshake"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("EstrattoConto")}</h3>
                    </div>
                </div>
            </div>
            <form className="kt-form vertical-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                <div className="kt-portlet__body">
                    <div className="form-group kt-form login-form__group row dashed-border-bottom">
                        <label className="col-lg-1 col-form-label">{Trad.Trad("EstrattoConto")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <input onChange={this.OnChange} type="text" value={this.state.ParametriUtente["ID_EstrattoConto"] || ""} name="ParametriUtente[ID_EstrattoConto]" className="form-control kt-input" placeholder={Trad.Trad("ID")} />
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("Data")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <div className="form-control">
                                <CampoData ValoreInArrivo={false}
                                    Name="ParametriUtente[Data]"
                                    Id="ParametriUtente[Data]"
                                    Valore={this.state.ParametriUtente["Data"]}
                                    OnChange={this.OnChange} />
                            </div>
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("Stato")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <Tipo Campo="ParametriUtente[ID_TipoEstrattoContoStato]" ID_ChiaveString={this.state.ParametriUtente["ID_TipoEstrattoContoStato"] || ""} OnAggiorna={this.OnChange} Dati={this.state.Dati != undefined ? this.state.Dati.Tipi["EstrattoContoStato"] : undefined} />
                        </div>
                    </div>
                    <div className="form-group kt-form login-form__group row">
                        <label className="col-lg-1 col-form-label">{Trad.Trad("Da")}</label>
                        <div className="col-lg-5 form-control-plaintext">
                            <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="ParametriUtente[ID_AnagDa]" ID_ChiaveString={this.state.ParametriUtente["ID_AnagDa"] || ""} OnAggiorna={this.OnChange} TradValori />
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("A")}</label>
                        <div className="col-lg-5 form-control-plaintext">
                            <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="ParametriUtente[ID_AnagA]" ID_ChiaveString={this.state.ParametriUtente["ID_AnagA"] || ""} OnAggiorna={this.OnChange} TradValori />
                        </div>
                    </div>
                </div>
                <div className="kt-portlet__foot kt-portlet__foot--fit">
                    <div className="kt-form login-form__actions kt-form login-form__actions--middle">
                        <div className="row">
                            <div className="col kt-form__actions kt-form__actions--center">
                                <Bottone Default Attesa={this.state.Caricamento} OnClick={(e) => { this.state.ParamAPIPagine.Pagina = 1; this.setState({ Parametri: this.CopiaListaParametri(this.state.ParametriUtente, true), ParamAPIPagine: this.state.ParamAPIPagine, Caricamento: true, Aggiornare: this.state.Aggiornare + 1 }) }} Testo={Trad.Trad("Cerca")} />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <Paginatore Pagina={this.state.ParamAPIPagine.Pagina} Pagine={this.state.Dati == undefined ? 0 : this.state.Dati.Pagine} OnCambioPagina={this.OnCambioPagina} />
            <div>
                <table className="table table-hover dtr-inline dataTable" id="tabella" ref="tabella">
                    <thead>
                        <tr className="sfondoTab">
                            <th scope="row" className="TextCenter">{Trad.Trad("EstrattoConto")}</th>
                            <th scope="row" className="TextCenter">{Trad.Trad("Da")}</th>
                            <th scope="row" className="TextCenter">{Trad.Trad("A")}</th>
                            <th scope="row" className="TextCenter">{Trad.Trad("DataDa")}</th>
                            <th scope="row" className="TextCenter">{Trad.Trad("DataA")}</th>
                            <th scope="row" className="TextRight">{Trad.Trad("Totale")}</th>
                            <th scope="row" className="TextCenter">{Trad.Trad("Stato")}</th>
                            <th data-field="edit" className="TextCenter"></th>
                        </tr>
                    </thead>
                    <ChiamaAPI Aggiornare={this.state.Aggiornare} URL="/api/EstrattoConto/Ricerca" ParamURLClasse={this.state.ParamAPIPagine} OnInvio={this.OnInvio} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErroreEstrattoConto} />
                </table>
            </div>
            {Scrittura &&
                <div className="kt-portlet__foot kt-portlet__foot--fit">
                    <div className="kt-form login-form__actions kt-form login-form__actions--left">
                        <div className="col kt-form__actions kt-form__actions--left">
                            <div className="col-lg-12 kt--align-left">
                                <div className="divtabella">
                                    <Bottone OnClick={(e) => { this.props.history.push("/EstrattoContoQuietanze") }} Testo={Trad.Trad("Nuovo")} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/EstrattoContoLista.tsx